<template>
    <custom-table
        :fields="$data.$fields"
        :items="items"
        outlined
        items-empty-message="Todavía no hay facturas."
        class="w-full"
    >
        <template #cell(type)="data">
            {{ typeLabel(data.item.type) }}
        </template>
        <template #cell(period)="data">
            <template v-if="data.item.periodStart">
                {{ data.item.periodStart | dateSimple }}
                <template v-if="data.item.periodEnd">
                    → {{ data.item.periodEnd | dateSimple }}
                </template>
            </template>
            <span v-else class="text-theme-muted">—</span>
        </template>
        <template #cell(amount)="data">
            {{ data.item.amount | money }}
            <span
                v-if="data.item.creditAmount"
                class="block text-xs text-theme-muted"
            >
                Crédito: {{ data.item.creditAmount | money }}
            </span>
        </template>
        <template #cell(status)="data">
            <span
                class="rounded-full px-2 py-0.5 text-xs font-semibold"
                :class="statusMeta(data.item.status).class"
            >
                {{ statusMeta(data.item.status).label }}
            </span>
        </template>
        <template #cell(dueDate)="data">
            {{ data.item.dueDate | date }}
        </template>
        <template #cell(paidAt)="data">
            <template v-if="data.item.paidAt">
                {{ data.item.paidAt | date }}
            </template>
            <span v-else class="text-theme-muted">—</span>
        </template>
    </custom-table>
</template>

<script>
import CustomTable from "@/components/utils/CustomTable.vue";

const TYPE_LABELS = {
    renewal: "Renovación",
    purchase: "Compra de plan",
    upgrade: "Subida de plan"
};

const STATUS_META = {
    pending: { label: "Pendiente", class: "bg-theme-warning text-black" },
    paid: { label: "Pagada", class: "bg-theme-success text-white" },
    overdue: { label: "Vencida", class: "bg-theme-danger text-white" },
    void: { label: "Anulada", class: "bg-theme-muted text-theme-inverse" }
};

export default {
    name: "PlatformInvoicesTable",
    components: { CustomTable },
    props: {
        items: {
            type: Array,
            default: () => []
        }
    },
    data: () => ({
        $fields: [
            { key: "planName", label: "Plan", sortable: false },
            { key: "type", label: "Tipo", sortable: false },
            { key: "period", label: "Periodo que cubre", sortable: false },
            { key: "amount", label: "Monto", sortable: false },
            { key: "status", label: "Estado", sortable: false },
            { key: "dueDate", label: "Vence", sortable: false },
            { key: "paidAt", label: "Pagada el", sortable: false }
        ]
    }),
    methods: {
        typeLabel(type) {
            return TYPE_LABELS[type] || type;
        },
        statusMeta(status) {
            return (
                STATUS_META[status] || {
                    label: status,
                    class: "bg-theme-muted text-theme-inverse"
                }
            );
        }
    }
};
</script>
